export const MarketAreaStateQueryKeys = {
	all: ['market-area-state'] as const,
	details: (marketAreaId: number, fromDate: string, toDate: string) => [...MarketAreaStateQueryKeys.all, 'details', marketAreaId, fromDate, toDate] as const,
};

export const MarketAreaQueryKeys = {
	all: ['market-area'] as const,
	details: () => [...MarketAreaQueryKeys.all, 'details'] as const,
	detail: (marketAreaId: number) => [...MarketAreaQueryKeys.details(), 'detail', marketAreaId] as const,
};